import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { I18N } from 'commons';

import './WeeklySelector.scss';

const WeeklySelector = ({
  values,
  readOnly,
  onChange,
  ...attrs
}) => {
  const i18nPrefix = 'component.weekly.selector';
  const i18nDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  const isChecked = value => values.indexOf(value);

  const renderDayBlocks = () => (
    i18nDays.map((value, index) => {
      const checked = (isChecked(index + 1) !== -1);
      return (
        <div className="d-inline-block mr-3">
          <input
            type="checkbox"
            id={`checkbox_${value}`}
            checked={checked}
            disabled={readOnly}
            onChange={() => handleClick(index + 1)}
          />
          <label htmlFor={`checkbox_${value}`}><I18N>{`${i18nPrefix}.${value}`}</I18N></label>
        </div>
      );
    })
  );

  const [dayBlocks, updateDayBlocks] = useState(renderDayBlocks());

  const handleClick = (value) => {
    if (readOnly) {
      return;
    }
    const index = isChecked(value);
    if (index !== -1) {
      values.splice(index, 1);
    } else {
      values.push(value);
    }
    if (onChange) {
      onChange(values);
    }
    updateDayBlocks(renderDayBlocks());
  };

  return (
    <div className="weekly-selector" {...attrs}>
      {
        dayBlocks
      }
    </div>
  );
};

WeeklySelector.propTypes = {
  values: PropTypes.array.isRequired,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

WeeklySelector.defaultProps = {
  readOnly: false,
  onChange: () => {}
};

export default WeeklySelector;
